import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleCustomerDetails = () => {
  const { customerId } = useParams();
  const decodedId = customerId ? atob(customerId) : customerId;
  const id = decodedId.replace(/\D/g, ''); // Ensure we only get the numeric part
  const [customerDetails, setCustomerDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customer}${id}/`, { headers });
        const extractedColumns = Object.keys(response.data);

        // Define which columns to exclude (if necessary)
        const excludedColumns = ['id', 'created_at'];
        const columnsArray = extractedColumns
          .filter((column) => !excludedColumns.includes(column))
          .map((column) => ({
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          }));

        setColumnDetails(columnsArray);
        setCustomerDetails(response.data);
      } catch (error) {
        console.error('Error fetching customer details:', error);
      }
    };

    fetchCustomerDetails();
  }, [customerId]);

  return (
    <div>
      {customerDetails ? (
        <SingleItemDetailTemplate details={customerDetails} columns={columns} />
      ) : (
        <p>Loading customer details...</p>
      )}
    </div>
  );
};

export default SingleCustomerDetails;